export const FEATURE_STATUS = {
  ENABLED: 'enabled',
  DISABLED: 'disabled',
};
